module.exports = __webpack_public_path__ + "static/media/3.ecfa28f3.jpg";